/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createLoginPageStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    maxWidth: '400px',
    marginTop: theme.spacing(1),
  },
  formFooter: {
    alignItems: 'center',
  },
  forgotStyle: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  forgotTextStyle: {
    color: theme.palette.tertiary.main,
    marginLeft: '5px',
    marginBottom: '15px',
  },
  formTitle: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    fontSize: '1.6rem',
    fontWeight: 600,
  },
  formSubtitle: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingBottom: '0.3rem',
    fontSize: '1.1rem',
    lineHeight: 1.1,
  },
  formGroup: {
    marginBottom: '0.2rem',
    minHeight: '66px',
    fontWeight: 500,
  },
  errorBlock: {
    marginTop: '10px',
    marginBottom: '5px',
    fontWeight: 500,
  },
  errorLine: {
    color: theme.palette.error.main,
    margin: '2px 0px',
    marginLeft: '1.8rem',
    cursor: 'help',
  },
  sso: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: '20px',
  },
  ssoOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '15px',
  },
  formHelperTextPadding: {
    padding: '7px 50px 7px 0 !important',
  },
  button: {
    width: '206px',
    maxWidth: '206px',
  },
  buttonRoot: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    width: '142px',
    maxWidth: '142px',
  },
  buttonMainText: {
    fontSize: '14px',
    fontWeight: 900,
    textTransform: 'uppercase',
    letterSpacing: '-0.011px',
    color: 'inherit',
    lineHeight: 1.3,
  },
  buttonHelperText: {
    fontSize: '10px',
    fontWeight: 400,
    textTransform: 'none',
    letterSpacing: '-0.011px',
    color: 'inherit',
    lineHeight: 1.3,
  },
  orgsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingTop: '15px',
    width: '100%',
  },
  noneAnnotation: {
    textAlign: 'center',
    maxWidth: '700px',
  },
  loginOption: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export { createLoginPageStyles };
